import { action, observable } from 'mobx';
import stores from '../../../models/Stores';
import { UserIdentity } from 'cd-eft/security/UserIdentity';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';
import MessageCenter from '../MessageCenter/MessageCenterVM';
import { AxiosResponse } from 'axios';
import { IApplicationFlags } from 'cd-eft/models/Stores/UserProfileStore';
import { FlagDto } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';

const AppStore = stores.AppStore;

export class LoginVM {
  props: any;
  history: any;
  constructor(props: undefined, history) {
    this.props = props;
    this.history = history;
  }

  @observable user = {
    email: '',
    password: '',
  };

  @observable formErrors = {
    email: '',
    password: '',
  };

  @observable credentialError = '';

  @observable activeInput = {
    email: false,
    password: false,
  };

  @observable emailValid = false;
  @observable passwordValid = false;
  @observable formValid = false;

  @action.bound clearErrors() {
    this.formErrors = {
      email: '',
      password: '',
    };
    this.formValid = false;
  }

  @action.bound handleClick(e) {
    const { value } = e.target;
    const { name } = e.target;
    if (value.length > 0) {
      this.activeInput[name] = true;
    }
    if (!value || value.length === 0) {
      this.activeInput[name] = false;
    }
  }

  @action.bound handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = event.target.name;

    this.user[name] = value;

    if (this.credentialError && value.length > 0) {
      this.credentialError = '';
    }

    if (!value || value.length === 0) {
      this.clearErrors();
      return;
    }

    this.validateField(name, value);
  }

  @action.bound async onSubmit(e) {
    try {
      e.preventDefault();

      if (this.user.email.length > 0 && this.user.email !== '') {
        AppStore.userProfileStore.userName = this.user.email;
      }

      // attempt login
      try {
        //remove any messages that might be lingering (e.g. 401 authorization)
        MessageCenter.clearMessages();

        await UserIdentity.login(this.user.email, this.user.password);
        //clear the form data after successful login
        this.user.email = '';
        this.user.password = '';
      } catch (error) {
        this.credentialError = 'Invalid credentials. Please try again.';
        return; //exit current procedure
      }

      //register user - this call is necessary for first time logins to add the authenticated user to the application database
      await PRJAPI.UserInfoController.selfRegisterUsingPOST();

      // now get user preferences
      const response = (await PRJAPI.UserPreferenceController.getAllUserPreferencesUsingGET(UserIdentity.username!))
        .data;
      if (response.length) {
        AppStore.userProfileStore.userPreferences = response as any;
        AppStore.userProfileStore.lastSavedUserPreferencesJSON = JSON.stringify(
          AppStore.userProfileStore.userPreferences
        );
      }

      await this.getAllFlags();

      AppStore.userProfileStore.userAvailable = true;
      AppStore.efh2Store.basicDataForm.user = AppStore.userProfileStore.userName;

      // change the current route to home page
      this.history.push('/');
    } catch (error) {
      throw error;
    }
  }

  @action.bound validateField(fieldName, value) {
    const fieldValidationErrors = this.formErrors;
    let emailValid = this.emailValid;
    let passwordValid = this.passwordValid;

    switch (fieldName) {
      case 'email':
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = emailValid ? '' : ' Email address is invalid.';
        break;
      case 'password':
        passwordValid = value.length >= 6;
        fieldValidationErrors.password = passwordValid ? '' : ' Your password must be at least 6 characters.';
        break;
      default:
        break;
    }

    this.formErrors = fieldValidationErrors;
    this.emailValid = emailValid;
    this.passwordValid = passwordValid;
    this.validateForm();
  }

  @action.bound validateForm() {
    this.formValid = this.emailValid && this.passwordValid;
  }

  @action.bound errorClass() {
    if (this.credentialError) {
      return 'usa-input--error';
    } else return;
  }
  private async getAllFlags() {
    try {
      const response: AxiosResponse<FlagDto> = await PRJAPI.FfsController.getAllFlagsUsingGET();
      if (response.data && response.data.result) {
        const reducedValues = response.data.result.reduce(
          (obj, item) => Object.assign(obj, { [item.keyName!]: item.keyValue === 'true' ? true : false }),
          {}
        );
        AppStore.userProfileStore.applicationFlags = reducedValues as IApplicationFlags;
      }
    } catch (error) {
      MessageCenter.addError((error as Error).message);
      return;
    }
  }
}
